export default __webpack_public_path__ + "static/media/1900.38897f20.png";